import { useState, useEffect } from 'react';
import { useRouter } from 'next/router';

export function useLayout() {
  const router = useRouter();
  const [canScrollBody, setCanScrollBody] = useState<boolean>(true);
  const [hideHeader, setHideHeader] = useState<boolean>(false);

  useEffect(() => {
    document.body.classList.toggle(
      'disable-overflow-scroll',
      canScrollBody !== true,
    );
  }, [canScrollBody]);

  useEffect(() => {
    document.body.classList.toggle('hide-fixed-header', hideHeader === true);
  }, [hideHeader]);

  useEffect(() => {
    // when the user navigates to a new page, reset the state of the hidden header so it becomes visible again
    const handleRouteChange = () => {
      setHideHeader(false);
    };

    router.events.on('routeChangeStart', handleRouteChange);

    return () => {
      router.events.off('routeChangeStart', handleRouteChange);
    };
  }, [router]);

  return {
    canScrollBody,
    setCanScrollBody,
    hideHeader,
    setHideHeader,
  };
}
